// MediaPage.vue
<template lang="pug">
.page
  .buttons
    Button3d(@click="showFilter = !showFilter")
      icon.small(name="filter")
    div(style="flex: 1 0")
    div Total: {{ total }}
  .filter-panel(v-show="showFilter")
    MediaFilter(@runFilter="runFilter")
  MediaGallery
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import MediaFilter from "./MediaFilter.vue";
import MediaGallery from "./MediaGallery.vue";
import Icon from "@/components/Icon.vue";
import Button3d from "@/components/Button3d.vue";

export default {
  name: "MediaPage",
  components: { MediaFilter, MediaGallery, Icon, Button3d },
  data() {
    return {
      index: null,
      urls: null,
      filterVisible: false,
      center: { lat: 54.153796, lng: 8.945332 },
      zoom: 13,
      selectedIndex: 0,
      showModal: false,
      showFilter: false,
    };
  },
  computed: {
    ...mapGetters({
      total: "media/total",

    }),
  },
  methods: {
    ...mapActions({
      clear: "media/clear",
    }),
    runFilter() {
      this.clear();
      this.showFilter = false;
    },
  },
  mounted() {},
};
</script>

<style scoped>
.page {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1rem;
  position: relative;
  overflow: auto;
}
.buttons {
  display: flex;
  flex-flow: row;
  justify-content: flex-start;
  font-size: 3vw;
  color: black;
  align-items: center;
}
.filter-panel {
  margin-bottom: 1rem;
  padding: 1rem;
  background: #eee;
  border: 1px solid #ccc;
  border-radius: 4px;
}
</style>